exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".am-query .ant-calendar-picker {\n  width: 100% !important;\n}\n.am-query .normal-filter-item:nth-child(2) {\n  width: 58%;\n}\n.am-query .normal-filter-item:nth-child(2) .ant-select {\n  width: 50%;\n}\n.am-query .normal-filter-item:nth-child(2) .ant-select:first-child {\n  padding-right: 10px;\n}\n", ""]);

// exports
